/**
 * Shared Tailwind classes for rendering email HTML in-app (TipTap editor + preview).
 * Tailwind Preflight zeroes list markers; restore disc/decimal so ul/ol match email clients.
 */
export const EMAIL_HTML_SURFACE_CLASS = [
  'text-sm leading-normal',
  '[&_p]:my-0',
  '[&_blockquote]:my-2 [&_blockquote]:border-l-2 [&_blockquote]:border-border [&_blockquote]:pl-3 [&_blockquote]:italic',
  '[&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-6',
  '[&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-6',
  '[&_li]:my-0 [&_li>p]:my-0',
  '[&_a]:text-primary [&_a]:underline',
].join(' ');
